import styled, { css } from 'styled-components';

import { media, getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Title = styled(Typography).attrs({ variant: 'h4' })`
  ${({ theme, spacingTop }) =>
    spacingTop && theme.getFluidSpacing('margin-top', ...spacingTop)};
  ${({ theme, spacingBottom }) =>
    spacingBottom && theme.getFluidSpacing('margin-bottom', ...spacingBottom)};
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ withoutGapMobile }) => (withoutGapMobile ? '0' : '2rem')};

  ${media.from480up`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `}

  ${media.from800up`
    grid-template-columns: repeat(3, minmax(0, 1fr));
  `}
`;

export const TableRow = styled.div`
  flex-basis: 100%;

  ${media.from640up`
    flex-basis: 33%;
    ${({ isWider }) =>
      isWider &&
      css`
        grid-column: span 2;
      `}

  `}
`;

export const TableRowElement = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  color: ${getThemeColor('bluegrey.15')};
  ${({ theme, spacingTop }) =>
    spacingTop && theme.getFluidSpacing('margin-top', ...spacingTop)};
  ${({ theme, spacingBottom }) =>
    spacingBottom && theme.getFluidSpacing('margin-bottom', ...spacingBottom)};
`;

export const TableRowHeading = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  color: ${getThemeColor('bluegrey.60')};
  ${({ theme, spacingTop }) =>
    spacingTop && theme.getFluidSpacing('margin-top', ...spacingTop)};
  ${({ theme, spacingBottom }) =>
    spacingBottom && theme.getFluidSpacing('margin-bottom', ...spacingBottom)};
  font-weight: 500;
`;
